module.exports = __webpack_public_path__ + "static/media/testimonial_michal_heller.f7b24d1e.png";